export type PropertyType = 'casa' | 'apartamento' | 'terreno' | 'cobertura' | 'comercial' | 'rural' | 'kitnet' | 'sobrado';
export type PropertyPurpose = 'venda' | 'locacao' | 'venda_locacao';
export type PropertyStatus = 'disponivel' | 'vendido' | 'alugado' | 'reservado' | 'inativo';

export interface Property {
  id: string;
  title: string;
  description: string | null;
  type: PropertyType;
  purpose: PropertyPurpose;
  status: PropertyStatus;
  is_featured: boolean;
  is_new: boolean;
  
  // Location
  cep: string | null;
  state: string | null;
  city: string;
  neighborhood: string;
  street: string | null;
  number: string | null;
  complement: string | null;
  latitude: number | null;
  longitude: number | null;
  
  // Characteristics
  total_area: number | null;
  built_area: number | null;
  bedrooms: number;
  suites: number;
  bathrooms: number;
  parking_spots: number;
  
  // Pricing
  price: number;
  condo_fee: number | null;
  iptu: number | null;
  
  // Features
  features: string[];
  
  // Media
  main_image_url: string | null;
  video_url: string | null;
  virtual_tour_url: string | null;
  
  // SEO
  meta_title: string | null;
  meta_description: string | null;
  slug: string | null;
  
  // Metadata
  views_count: number;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  
  // Relations
  property_images?: PropertyImage[];
}

export interface PropertyImage {
  id: string;
  property_id: string;
  image_url: string;
  is_main: boolean;
  display_order: number;
  alt_text: string | null;
  created_at: string;
}

export interface Lead {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  message: string | null;
  source: string;
  property_id: string | null;
  status: 'novo' | 'em_atendimento' | 'respondido' | 'arquivado' | 'convertido';
  notes: string | null;
  created_at: string;
  updated_at: string;
  ip_hash?: string | null;
  user_agent?: string | null;
}

export interface Testimonial {
  id: string;
  client_name: string;
  client_photo_url: string | null;
  testimonial: string;
  rating: number;
  is_active: boolean;
  display_order: number;
  created_at: string;
}

export interface SiteSettings {
  id: string;
  broker_name: string;
  broker_photo_url: string | null;
  broker_bio: string | null;
  creci: string | null;
  phone: string | null;
  whatsapp: string | null;
  email: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  instagram: string | null;
  facebook: string | null;
  linkedin: string | null;
  youtube: string | null;
  hero_title: string;
  hero_subtitle: string;
  about_title: string;
  about_description: string | null;
  business_hours: string;
  years_experience: number;
  properties_sold: number;
  happy_clients: number;
  updated_at: string;
}

export const PROPERTY_TYPES: Record<PropertyType, string> = {
  casa: 'Casa',
  apartamento: 'Apartamento',
  terreno: 'Terreno',
  cobertura: 'Cobertura',
  comercial: 'Comercial',
  rural: 'Rural',
  kitnet: 'Kitnet',
  sobrado: 'Sobrado',
};

export const PROPERTY_PURPOSES: Record<PropertyPurpose, string> = {
  venda: 'Venda',
  locacao: 'Locação',
  venda_locacao: 'Venda e Locação',
};

export const PROPERTY_STATUSES: Record<PropertyStatus, string> = {
  disponivel: 'Disponível',
  vendido: 'Vendido',
  alugado: 'Alugado',
  reservado: 'Reservado',
  inativo: 'Inativo',
};

export const PROPERTY_FEATURES = [
  'Piscina',
  'Churrasqueira',
  'Academia',
  'Salão de Festas',
  'Playground',
  'Quadra',
  'Sauna',
  'Jardim',
  'Varanda',
  'Closet',
  'Home Office',
  'Ar Condicionado',
  'Aquecimento',
  'Lareira',
  'Elevador',
  'Portaria 24h',
  'Segurança',
  'Pet Friendly',
  'Mobiliado',
  'Vista Mar',
];
